var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"dext5",rawName:"v-dext5:loaded",value:(_vm.handleLoaded),expression:"handleLoaded",arg:"loaded"}],staticClass:"form-control-container",attrs:{"id":_vm.editorId}})}
var staticRenderFns = []

export { render, staticRenderFns }